import apiRoutes from './api.routes';
import api from './api.service';
import ModelService from './model.service';

const DocumentService = new ModelService(apiRoutes.documents, '/documents');

DocumentService.TODAY = 1;
DocumentService.YESTERDAY = 2;
DocumentService.LAST_WEEK = 3;
DocumentService.LATER = 4;

DocumentService.getData = params => api.catchError(async () => {
  const { data, headers: { 'x-total-count': count } } = await api.get(`${apiRoutes.documents}`, params);
  return { data, count: parseInt(count, 10) };
});


DocumentService.saveMany = params => api.catchError(async () => {
  const data = await api.post(`${apiRoutes.documents}`, params);
  return data;
});

DocumentService.getPage = (params) => {
  const { doc_id, page, token } = params;
  const firstPartToken = token.substr(0, 5);
  const secondPartToken = token.substr(5);
  return `${api.apiUrl}${apiRoutes.documents}${apiRoutes.slash}${doc_id}${apiRoutes.slash}${page}?token=${secondPartToken}${firstPartToken}`;
};

DocumentService.getBaseUrl = () => {
  return '/docs';
};


DocumentService.getFolderUrl = (folder_id) => {
  if (folder_id) {
    return `${DocumentService.getBaseUrl()}/folder/${folder_id}`;
  }
  return DocumentService.getBaseUrl();
};

DocumentService.getDocUrl = (document_id, folder_id) => {
  if (folder_id) {
    return `${DocumentService.getFolderUrl(folder_id)}/file/${document_id}`;
  }
  return `${DocumentService.getBaseUrl()}/file/${document_id}`;
};


DocumentService.modelName = 'documents';

DocumentService.TYPE_IMAGE = 'image';
DocumentService.TYPE_PDF = 'pdf';
DocumentService.TYPE_XLS = 'xls';
DocumentService.TYPE_DOC = 'doc';
DocumentService.TYPE_OTHER = 'other';

DocumentService.getExtList = t => ({
  [DocumentService.TYPE_IMAGE]: t('Image'),
  [DocumentService.TYPE_PDF]: 'Pdf',
  [DocumentService.TYPE_XLS]: 'Xls',
  [DocumentService.TYPE_DOC]: 'Doc',
  [DocumentService.TYPE_OTHER]: t('Other'),
});

DocumentService.getDatesNames = ({ t }) => ({
  [DocumentService.TODAY]: t('Today'),
  [DocumentService.YESTERDAY]: t('Yesterday'),
  [DocumentService.LAST_WEEK]: t('Last week'),
  [DocumentService.LATER]: t('Later'),
});

export default DocumentService;



// WEBPACK FOOTER //
// ./src/services/document.service.js